













import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal/modal-config.model";
import { ref, computed, Ref, onMounted } from "@vue/composition-api";
import AdminScope from "./AdminScope.vue";
import { clone } from "@/fp";
export default Vue.extend({
  components: { Modal, AdminScope },
  props: ["modalData"],
  setup(props, { emit }) {
    const modified_restrictions: Ref<string[]> = ref([]);
    const initial_restrictions: Ref<string[]> = ref([]);

    const has_no_changes = computed(
      () =>
        modified_restrictions.value.sort().join("_") ==
        initial_restrictions.value.sort().join("_")
    );
    const is_all_info_types_unchecked = computed(
      () =>
        modified_restrictions.value.reduce((acc, item) => {
          if (item.startsWith("it")) {
            acc++;
          }
          return acc;
        }, 0) === 6
    );

    const is_all_entity_types_unchecked = computed(
      () =>
        modified_restrictions.value.reduce((acc, item) => {
          if (item.startsWith("et")) {
            acc++;
          }
          return acc;
        }, 0) === 5
    );

    const config = computed(() => {
      return {
        title: "Modify Permissions",
        // @ts-ignore
        desc: `Change permissions for <b>${props.modalData.email}</b>`,
        width: "70rem",
        height: "auto",
        disableSave:
          is_all_info_types_unchecked.value ||
          is_all_entity_types_unchecked.value ||
          has_no_changes.value,
      } as ModalConfig;
    });

    const submit = () => {
      emit("submit", modified_restrictions.value);
    };

    onMounted(() => {
      console.log("data ::", props.modalData);
      // @ts-ignore
      modified_restrictions.value = [...props.modalData.restrictions];
      // @ts-ignore
      initial_restrictions.value = clone(props.modalData.restrictions);
    });
    return {
      config,
      submit,
      modified_restrictions,
      is_all_info_types_unchecked,
      is_all_entity_types_unchecked,
    };
  },
});
